"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMedia = void 0;
var react_1 = __importDefault(require("react"));
var selectors_1 = require("../redux/selectors");
var mediaQuerySlice_1 = require("../redux/slice/mediaQuerySlice");
var react_redux_1 = require("react-redux");
var useMedia = function () {
    var small = (0, react_redux_1.useSelector)(selectors_1.mediaQuerySelector).SMALL;
    var medium = (0, react_redux_1.useSelector)(selectors_1.mediaQuerySelector).MEDIUM;
    var dispatch = (0, react_redux_1.useDispatch)();
    react_1.default.useEffect(function () {
        var handleResize = function () {
            var isSmall = window.innerWidth <= small;
            var isMedium = window.innerWidth <= medium;
            dispatch((0, mediaQuerySlice_1.setMediaState)({ isSmall: isSmall, isMedium: isMedium }));
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
};
exports.useMedia = useMedia;
